// @flow
import React, { type Element, type Node } from 'react';
import { FormattedDate } from 'react-intl';
import './reviewPropertiesList.scss';
import categoryUtils from './categoryUtils';
import type { Reviews } from '../../../types';

type Props = {
  collapsed: boolean,
  review: Reviews,
};

type ReviewProperty = {
  name: string,
  title: string,
  value: Node,
};

const propertyIcon = {
  categoryOnCard: 'info-circled',
  workCompleted: 'clipboard-checkmark',
  cost: 'circle-dollars',
  dateOfService: 'calendar2',
  hireAgain: 'check-bullet-1',
  address: 'user',
};

const getPropertyIcon = icon => propertyIcon[icon];

const yesOrNo = choice => (choice ? 'Yes' : 'No');

class ReviewPropertiesListComponent extends React.Component<Props> {
  getAllCategoriesForCard: ((categoryIds: Array<number>) => string) = (categoryIds: number[]) => {
    const categoryNameList = categoryIds.map(categoryId => categoryUtils.fetchCategoryProperty(parseInt(categoryId, 10), 'name.en-us'));
    return categoryNameList.join(', ');
  }
  props: Props;


  buildPropertiesToDisplay: (() => Array<ReviewProperty>) = () => {
    const { categories } = this.props.review;

    const categoryNames =
    this.getAllCategoriesForCard(categories.map(category =>
      category.categoryId));

    const {
      review: {
        workCompleted,
        costOfService,
        dateOfService,
        willHireAgain,
        postalAddress,
      },
    } = this.props;
    const {
      addressFirstLine,
      addressSecondLine,
      postalCode,
      city: { name: cityName } = {},
      region: { abbreviation: regionAbbreviation } = {},
    } = postalAddress || {};
    const addressDisplay = (
      <div>
        <If condition={addressFirstLine}>
          <div>
            {addressFirstLine}
          </div>
        </If>
        <If condition={addressSecondLine}>
          <div>
            {addressSecondLine}
          </div>
        </If>
        <div>
          {`${cityName ? `${cityName}, ` : ''}${regionAbbreviation ? `${regionAbbreviation} ` : ''}${postalCode}`}
        </div>
      </div>
    );

    const properties: ReviewProperty[] = [
      {
        name: 'categoryOnCard',
        title: 'Category',
        value: categoryNames,
      },
      {
        name: 'workCompleted',
        title: 'Services Performed',
        value: yesOrNo(workCompleted),
      },
      ...(typeof costOfService !== 'undefined' ? [
        {
          name: 'cost',
          title: 'Cost',
          value: `$${Math.ceil(costOfService)}`,
        },
      ] : []),
      ...(!this.props.collapsed && dateOfService ? [
        {
          name: 'dateOfService',
          title: 'Work Completed Date',
          value: (
            <FormattedDate value={new Date(Date.parse(dateOfService))} />
          ),
        },
      ] : []),
      ...(!this.props.collapsed ? [
        {
          name: 'hireAgain',
          title: 'Hire Again',
          value: yesOrNo(willHireAgain),
        },
      ] : []),
      ...(postalAddress ? [
        {
          name: 'address',
          title: '',
          value: addressDisplay,
        },
      ] : []),
    ];

    return properties;
  }

  render(): Element<"ul"> {
    const properties = this.buildPropertiesToDisplay();

    return (
      <ul className="icon-ul review-card_properties">
        {properties.map(property => (
          <li
            className="review-card_property"
            key={property.name}
            ref={`property_${property.name}`}
          >
            <i className={`icon-li icon icon-${getPropertyIcon(property.name)}`} />
            {property.title ? `${property.title}: ` : ''}<strong>{property.value}</strong>
          </li>
        ))}
      </ul>
    );
  }
}

export default ReviewPropertiesListComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/ReviewPropertiesList.js